<template>
    <va-create-layout>
        <RefundEventShipmentItem-form
            :title="title"
            :item="item"
        ></RefundEventShipmentItem-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
